import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "./Spinner";
import { AuthContext } from "../context/AuthContext";
import "../style/deleteFancy.css"; 

const ENDPOINT =
    process.env.NODE_ENV === "development"
        ? "http://localhost:8000"
        : "https://api.bsf5050.com";

function DeleteFancy() {
    const [authContext] = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        fancyName: "",
        matchId: "",
        userId: "",
        odds: "",
    });

    const config = {
        headers: { Authorization: `Bearer ${authContext.token}` },
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // NEW: Helper function to determine input status
    const getValidationClass = (value, minLength = 2) => {
        if (!value) return ""; // Don't show red or green if it's completely empty
        return value.length >= minLength ? "success" : "error";
    };

    const handleSubmit = async (e) => {
        e.preventDefault(); 
        setLoading(true);
        console.log("Submitting form with data:", formData); // Debug log

        try {
            const payload = {
                ...formData,
                odds: Number(formData.odds)
            };

            const response = await axios.post(
                `${ENDPOINT}/api/v1/bet/deleteFancyOdds/6a322b474efc7ed9d514e8efbe254e234384urc87249r2vt59t6317851b80c5624deeaa65`, 
                payload, 
                config
            );
            
            console.log("Success:", response.data);
            alert(response.data);
            
            // setFormData({ fancyName: "", matchId: "", userId: "", odds: "" });
            
        } catch (error) {
            console.error("Error sending data:", error);
            alert("Failed to process request. Check console for details.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="settings-container" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Spinner color="#16a085" />
            </div>
        );
    }

    return (
        <div className="settings-container">
            <div className="settings-header">
                <h1>Delete Fancy Odds</h1>
            </div>
            
            <div className="settings-content">
                <form onSubmit={handleSubmit}>
                    <div className="settings-section">
                        <h2>Fancy Odds Details</h2>
                        
                        <div className="settings-grid">
                            {/* Notice how the className dynamically adds "success" or "error" */}
                            <div className={`setting-field ${getValidationClass(formData.fancyName, 3)}`}>
                                <label>Fancy Name</label>
                                <input 
                                    type="text" 
                                    name="fancyName" 
                                    value={formData.fancyName} 
                                    onChange={handleChange} 
                                    placeholder="e.g., 10 Over NSWW ADV."
                                    required 
                                />
                            </div>

                            <div className={`setting-field ${getValidationClass(formData.matchId, 4)}`}>
                                <label>Match ID</label>
                                <input 
                                    type="text" 
                                    name="matchId" 
                                    value={formData.matchId} 
                                    onChange={handleChange} 
                                    placeholder="e.g., 35352584"
                                    required 
                                />
                            </div>

                            <div className={`setting-field ${getValidationClass(formData.userId, 3)}`}>
                                <label>User ID</label>
                                <input 
                                    type="text" 
                                    name="userId" 
                                    value={formData.userId} 
                                    onChange={handleChange} 
                                    placeholder="e.g., sp215"
                                    required 
                                />
                            </div>

                            {/* For odds, we just check if they entered anything > 0 length */}
                            <div className={`setting-field ${getValidationClass(formData.odds, 1)}`}>
                                <label>Odds</label>
                                <input 
                                    type="number" 
                                    name="odds" 
                                    value={formData.odds} 
                                    onChange={handleChange} 
                                    placeholder="e.g., 47"
                                    required 
                                />
                            </div>

                            {/* Passwords usually need to be longer, so we check for at least 6 chars */}
                            
                        </div>
                    </div>

                    <div className="settings-footer">
                        <button type="submit" className="save-btn" disabled={loading}>
                            {loading ? "Processing..." : "Submit Deletion"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default DeleteFancy;